<template>
  <vx-card>
    <div class="vx-col mb-6 mt-3">
      <div class="vx-row w-1/2">
        <div class="vx-col sm:w-1/3 w-full">
          <span style="font-weight: 600; color: #2c3e50">CL Request ID</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-model="clRequestId"
            type="text"
            disabled
            style="background: #f8f9fa"
          />
        </div>
      </div>
      <div class="vx-row w-1/2 mt-2">
        <div class="vx-col sm:w-1/3 w-full">
          <span style="font-weight: 600; color: #2c3e50">Territory</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-model="territory"
            type="text"
            disabled
            style="background: #f8f9fa"
          />
        </div>
      </div>
      <div class="vx-row w-1/2 mt-2">
        <div class="vx-col sm:w-1/3 w-full">
          <span style="font-weight: 600; color: #2c3e50">Customer Group</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-model="customerGroup1"
            type="text"
            disabled
            style="background: #f8f9fa"
          />
        </div>
      </div>
    </div>

    <vs-table
      stripe
      border
      description
      :sst="true"
      :data="table.data.credit_limit_reguler_customers"
      :max-items="table.length"
      :total="table.total"
      @search="handleSearch"
      @change-page="handleChangePage"
      @sort="handleSort"
      style="overflow-y: auto"
      class="credit-limit-table"
    >
      <template slot="header"> </template>
      <template slot="thead">
        <vs-th sort-key="option">Customer Codes</vs-th>
        <vs-th sort-key="so_data">SO Data</vs-th>
        <vs-th sort-key="ar_data">Active Month Transaction</vs-th>
        <vs-th sort-key="billing_data">Billing Data</vs-th>
        <vs-th sort-key="payment_data">Payment Data</vs-th>
        <vs-th sort-key="current_cl">Current CL</vs-th>
        <vs-th sort-key="suggested_cl">Suggested CL</vs-th>
        <vs-th sort-key="new_cl">New CL</vs-th>
        <vs-th sort-key="exclude">Exclude</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="customer-code">
              <strong>{{ tr.customer_code }}</strong>
            </div>
          </vs-td>
          <vs-td>
            <div class="data-cell">
              <div class="data-row">
                <span class="label">Total Sales</span>
                <span class="value">{{ tr.total_sales | numberFormat }}</span>
              </div>
              <div class="data-row">
                <span class="label">Average Sales</span>
                <span class="value">{{
                  tr.total_average_sales | numberFormat
                }}</span>
              </div>
            </div>
          </vs-td>
          <vs-td>
            <div class="month-transaction-container">
              <div class="month-header">
                <feather-icon icon="TrendingUpIcon" svgClasses="w-4 h-4" />
                <span>Monthly Sales</span>
              </div>
              <div
                class="month-cards"
                v-if="
                  tr.credit_limit_reguler_average_sales &&
                  tr.credit_limit_reguler_average_sales.length > 0
                "
              >
                <div
                  class="month-card"
                  :key="i"
                  v-for="(ts, i) in getSortedMonths(
                    tr.credit_limit_reguler_average_sales
                  )"
                >
                  <div class="month-name">
                    {{ ts.month_average | monthFormat }}
                  </div>
                  <div class="month-amount">
                    {{ ts.month_average_total | numberFormat }}
                  </div>
                </div>
              </div>
              <div v-else class="empty-state">
                <feather-icon icon="InboxIcon" svgClasses="w-5 h-5" />
                <span>No monthly data</span>
              </div>
            </div>
          </vs-td>
          <vs-td>
            <div class="data-cell">
              <div class="data-row">
                <span class="label">Active Transaction</span>
                <span class="value">{{ tr.active_transaction }}</span>
              </div>
              <div class="data-row">
                <span class="label">AR Overdue</span>
                <span class="value">{{ tr.ar_overdue | numberFormat }}</span>
              </div>
            </div>
          </vs-td>
          <vs-td>
            <div class="data-cell">
              <div class="data-row">
                <span class="label">Average Payment</span>
                <span class="value">{{ tr.average_payment }}</span>
              </div>
              <div class="data-row">
                <span class="label">Number Late Payment</span>
                <span class="value">{{ tr.num_of_late_payment }}</span>
              </div>
              <div class="data-row">
                <span class="label">Average Late Payment</span>
                <span class="value">{{ tr.average_late_payment }}</span>
              </div>
            </div>
          </vs-td>
          <vs-td>
            <div class="amount-cell">
              {{ tr.current_credit_limit | numberFormat }}
            </div>
          </vs-td>
          <vs-td>
            <div class="amount-cell suggested">
              {{ tr.suggested_credit_limit | numberFormat }}
            </div>
          </vs-td>
          <vs-td>
            <NumberInput
              v-if="show == false"
              v-model="data[indextr].credit_limit_request"
              min="1"
            />

            <div v-else class="amount-cell new-cl">
              {{ tr.credit_limit_request | numberFormat }}
            </div>
          </vs-td>

          <vs-td>
            <vs-checkbox
              v-if="show == false"
              v-model="data[indextr].is_exclude"
              type="checkbox"
              placeholder="Exclude"
            />
            <vs-checkbox
              v-else
              v-model="data[indextr].is_exclude"
              type="checkbox"
              placeholder="Exclude"
              disabled
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="vx-row mb-12" v-if="show == false">
      <div class="vx-col w-full flex items-center space-x-2">
        <vs-button
          class="mt-2"
          color="success"
          type="border"
          icon-pack="feather"
          icon="icon-save"
          @click="handleSave()"
          >Save</vs-button
        >
        <vs-button
          class="mt-2"
          color="success"
          type="border"
          icon-pack="feather"
          icon="icon-printer"
          @click="handlePrint()"
          >Print</vs-button
        >
        <vs-button
          class="mt-2"
          color="success"
          type="border"
          icon-pack="feather"
          icon="icon-download"
          @click="exportData()"
          >Export</vs-button
        >
        <vs-button
          class="mt-2"
          color="danger"
          type="border"
          icon-pack="feather"
          icon="icon-arrow-left"
          @click="closeDetail()"
          >Back</vs-button
        >
      </div>
    </div>
    <div class="vx-row mb-12" v-else>
      <div class="vx-col w-full flex items-center space-x-2">
        <vs-button
          class="mt-2"
          color="danger"
          type="border"
          icon-pack="feather"
          icon="icon-arrow-left"
          @click="closeDetail()"
          >Back</vs-button
        >
      </div>
    </div>
  </vx-card>
</template>
<script>
import moment from "moment";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import NumberInput from "@/components/master/NumberInput.vue";

export default {
  components: { NumberInput },
  props: {
    id: {
      type: Number,
    },
    show: {
      type: Boolean,
      default: false,
    },
    done: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deleteId: null,
      clRequestId: "",
      territory: "",
      customerGroup1: "",
      dateStart: moment().format("YYYY-MM-DD"),
      dateEnd: moment().format("YYYY-MM-DD"),
      table: this.tableDefaultState(),
    };
  },
  mounted() {
    this.getData();
    //set default all data[indextr].credit_limit_request is current_credit_limit
  },
  methods: {
    getSortedMonths(monthsData) {
      if (!monthsData || monthsData.length === 0) return [];
      // Sort by month_average in ascending order (July=7, August=8, September=9)
      return [...monthsData].sort((a, b) => a.month_average - b.month_average);
    },
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 1,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    closeDetail(params = false) {
      window.scrollTo(0, 0);
      this.detail = false;
      this.selectedData = {
        ID: 0,
      };
      if (params == true) {
        this.reloadData(this.params);
      }
      this.$emit("closeDetail", params);
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/master/credit-limit-regulers-id", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            // sort: this.table.sort,
            id: this.id,
            is_done: this.done,
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data;
            this.clRequestId = resp.data.code;
            this.territory = resp.data.territory_name;

            // Debug: Log data untuk melihat struktur
            console.log("Credit Limit Reguler Data:", resp.data);
            if (
              resp.data.credit_limit_reguler_customers &&
              resp.data.credit_limit_reguler_customers.length > 0
            ) {
              console.log(
                "Average Sales Data:",
                resp.data.credit_limit_reguler_customers[0]
                  .credit_limit_reguler_average_sales
              );
            }

            if (resp.data.credit_limit_customer_group != null) {
              this.customerGroup1 = "";
              for (
                let i = 0;
                i < resp.data.credit_limit_customer_group.length;
                i++
              ) {
                if (
                  resp.data.credit_limit_customer_group[i].customer_group_id !=
                  0
                ) {
                  this.customerGroup1 +=
                    resp.data.credit_limit_customer_group[i].code + ", ";
                } else {
                  this.customerGroup1 = "ALL";
                }
              }
            } else {
              this.customerGroup1 = "ALL";
            }
            // for (
            //   let i = 0;
            //   i < resp.data.credit_limit_reguler_customer_group.length;
            //   i++
            // ) {
            //   if (
            //     resp.data.credit_limit_reguler_customer_group[i]
            //       .customer_group_id != 0
            //   ) {
            //     this.customerGroup1 +=
            //       resp.data.credit_limit_reguler_customer_group[i].code + ", ";
            //   } else {
            //     this.customerGroup1 = "ALL";
            //   }
            // }

            this.setStartEnd();
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;

      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    exportData() {
      if (this.id != null) {
        this.$http
          .get("/api/v1/master/credit-limit-regulers-export", {
            params: {
              title:
                "Credit_Limit_Reguler" +
                "OMS" +
                "_" +
                this.dateStart +
                "_-_" +
                this.dateEnd,
              type_tab: "WMS",
              credit_limit_reguler_id: this.id,
            },
          })
          .then((resp) => {
            console.log("rrrrrrr", resp);
            if (resp.code == 200) {
              this.$vs.notify({
                title: "Success",
                text: "Export Processing in Tab Export",
                color: "success",
                iconPack: "feather",
                position: "top-right",
                icon: "icon-check-circle",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
            }
          });
      } else {
        this.$vs.notify({
          title: "Error",
          text: "Please select data first",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
      }
    },
    // handleSave() {
    //   let creditLimitRegulerCustomer =
    //     this.table.data.credit_limit_reguler_customers;
    //   let isExclude = creditLimitRegulerCustomer.filter(
    //     (v) => v.is_exclude == false
    //   );
    //   let isExcludeCreditLimitRequest = isExclude.filter(
    //     (v) => v.credit_limit_request == v.current_credit_limit
    //   );
    //   let newCLisNullOrZero = creditLimitRegulerCustomer.filter(
    //     (v) => v.credit_limit_request == 0 || v.credit_limit_request == null
    //   );
    //   let newCLisLessThanCurrent = creditLimitRegulerCustomer.filter(
    //     (v) => v.credit_limit_request > v.current_credit_limit
    //   );
    //   if (newCLisNullOrZero.length > 0) {
    //     this.$vs.loading.close();
    //     this.$vs.notify({
    //       title: "Error",
    //       text: "New Credit Limit cant be 0 or null",
    //       color: "danger",
    //       iconPack: "feather",
    //       position: "top-right",
    //       icon: "icon-alert-circle",
    //     });
    //     return;
    //   }
    //   if (newCLisLessThanCurrent.length > 0) {
    //     this.$vs.loading.close();
    //     this.$vs.notify({
    //       title: "Error",
    //       text: "New Credit Limit cant be bigger than Current Credit Limit",
    //       color: "danger",
    //       iconPack: "feather",
    //       position: "top-right",
    //       icon: "icon-alert-circle",
    //     });
    //     return;
    //   }
    //   if (isExcludeCreditLimitRequest.length > 0) {
    //     this.$vs.loading.close();
    //     this.$vs.notify({
    //       title: "Error",
    //       text: "Credit Limit Request cant same with Current Credit Limit",
    //       color: "danger",
    //       iconPack: "feather",
    //       position: "top-right",
    //       icon: "icon-alert-circle",
    //     });
    //     return;
    //   }
    //   this.$vs.loading();
    //   this.table.data.credit_limit_reguler_customers.forEach((element) => {
    //     element.credit_limit_reguler_id = Number(
    //       element.credit_limit_reguler_id
    //     );
    //     element.is_exclud = element.is_exclude;
    //
    //     element.credit_limit_request = Number(element.credit_limit_request);
    //     delete element.is_exclude;
    //   });
    //   this.$http
    //     .put("/api/v1/master/credit-limit-regulers", {
    //       credit_limit_customer: this.table.data.credit_limit_reguler_customers,
    //       id: this.id,
    //     })
    //     .then((resp) => {
    //       if (resp.code == 200) {
    //         this.$vs.notify({
    //           title: "Success",
    //           text: resp.message,
    //           color: "success",
    //           iconPack: "feather",
    //           position: "top-right",
    //           icon: "icon-check-circle",
    //         });
    //         this.$vs.loading.close();
    //         this.closeDetail(false);
    //       } else {
    //         this.$vs.loading.close();
    //         this.$vs.notify({
    //           title: "Error",
    //           text: resp.message,
    //           color: "danger",
    //           iconPack: "feather",
    //           icon: "icon-alert-circle",
    //         });
    //       }
    //     });
    // },
    handleSave() {
      let creditLimitRegulerCustomer =
        this.table.data.credit_limit_reguler_customers;
      let newCLisNullOrZero = creditLimitRegulerCustomer.some(
        (v) =>
          !v.is_exclude &&
          (!v.credit_limit_request || v.credit_limit_request == 0)
      );

      if (newCLisNullOrZero.length > 0) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: "New Credit Limit can't be 0 or null",
          color: "danger",
          iconPack: "feather",
          position: "top-right",
          icon: "icon-alert-circle",
        });
        return;
      }

      for (let customer of creditLimitRegulerCustomer) {
        // if (customer.current_credit_limit > customer.suggested_credit_limit) {
        //   if (customer.credit_limit_request > customer.current_credit_limit) {
        //     this.$vs.loading.close();
        //     this.$vs.notify({
        //       title: "Error",
        //       text: "New Credit Limit can't be greater than Current Credit Limit when Current Credit Limit is greater than Suggested Credit Limit",
        //       color: "danger",
        //       iconPack: "feather",
        //       position: "top-right",
        //       icon: "icon-alert-circle",
        //     });
        //     return;
        //   }
        // } else {
        //ini dicomment dulu karena ada perubahan di validasi dari SDN tiket MIX2-5652 --> sampai tanda RRR bberikutnya
        // if (customer.credit_limit_request > customer.suggested_credit_limit) {
        //   this.$vs.loading.close();
        //   this.$vs.notify({
        //     title: "Error",
        //     text: "New Credit Limit can't be greater than Suggested Credit Limit when Suggested Credit Limit is greater than Current Credit Limit",
        //     color: "danger",
        //     iconPack: "feather",
        //     position: "top-right",
        //     icon: "icon-alert-circle",
        //   });
        //   return;
        // }
        ////RRR
        // }
      }

      this.$vs.loading();
      this.table.data.credit_limit_reguler_customers.forEach((element) => {
        element.credit_limit_reguler_id = Number(
          element.credit_limit_reguler_id
        );
        element.is_exclud = element.is_exclude;
        element.credit_limit_request = Number(element.credit_limit_request);
        delete element.is_exclude;
      });

      this.$http
        .put("/api/v1/master/credit-limit-regulers", {
          credit_limit_customer: this.table.data.credit_limit_reguler_customers,
          id: this.id,
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.$vs.notify({
              title: "Success",
              text: resp.message,
              color: "success",
              iconPack: "feather",
              position: "top-right",
              icon: "icon-check-circle",
            });
            this.$vs.loading.close();
            this.closeDetail(false);
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: resp.message,
              color: "danger",
              iconPack: "feather",
              icon: "icon-alert-circle",
            });
          }
        });
    },
    // handlePrint for print pdf using jsPDF:
    handlePrint() {
      this.$vs.loading();
      const currentDate = moment().format("YYYY-MM-DD");
      var fileTitle = "CREDIT_LIMIT_REGULER_" + currentDate;
      this.$http
        .get("/api/v1/master/credit-limit-regulers-id", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            id: this.id,
            is_done: this.done,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();

          if (resp.code != 200) {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            var data = resp.data;
            var customers = data.credit_limit_reguler_customers || [];

            // Resolve customer group
            var customerGroupName = "ALL";
            if (
              data.credit_limit_reguler_customer_group &&
              data.credit_limit_reguler_customer_group.length > 0
            ) {
              var groupNames = [];
              for (
                var g = 0;
                g < data.credit_limit_reguler_customer_group.length;
                g++
              ) {
                var grp = data.credit_limit_reguler_customer_group[g];
                if (grp.customer_group_id === 0) {
                  groupNames = ["ALL"];
                  break;
                }
                groupNames.push(grp.code);
              }
              customerGroupName = groupNames.join(", ");
            }

            var validFrom = moment(data.valid_from).format("DD MMM YYYY");
            var printDate = moment().format("DD MMM YYYY HH:mm");

            // A3 landscape for more room
            var doc = new jsPDF("l", "mm", [420, 297]);
            var pageW = 420;
            var col1 = 14;
            var col2 = 90;
            var col3 = 220;
            var col4 = 300;

            // ── Header bar ──────────────────────────────────────────
            doc.setFillColor(94, 77, 178);
            doc.rect(0, 0, pageW, 18, "F");
            doc.setTextColor(255, 255, 255);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(13);
            doc.text("CREDIT LIMIT REGULER", col1, 12);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(8);
            doc.text("Printed : " + printDate, pageW - 14, 12, {
              align: "right",
            });

            // ── Info block ───────────────────────────────────────────
            doc.setTextColor(44, 62, 80);
            doc.setFontSize(8.5);

            // Left column
            doc.setFont("helvetica", "bold");
            doc.text("CL Request ID", col1, 27);
            doc.text("Territory", col1, 34);
            doc.text("Customer Group", col1, 41);
            doc.text("Valid From", col1, 48);

            doc.setFont("helvetica", "normal");
            doc.text(": " + String(data.code || "-"), col2, 27);
            doc.text(": " + String(data.territory_name || "-"), col2, 34);
            doc.text(": " + customerGroupName, col2, 41);
            doc.text(": " + validFrom, col2, 48);

            // Right column
            doc.setFont("helvetica", "bold");
            doc.text("Growth", col3, 27);
            doc.text("Evaluation Period", col3, 34);
            doc.text("Multiplier", col3, 41);
            doc.text("Notes", col3, 48);

            doc.setFont("helvetica", "normal");
            doc.text(
              ": " + String(data.growth != null ? data.growth : "-") + "%",
              col4,
              27
            );
            doc.text(
              ": " +
                String(
                  data.evaluation_period != null ? data.evaluation_period : "-"
                ) +
                " month(s)",
              col4,
              34
            );
            doc.text(
              ": " + String(data.multiplier != null ? data.multiplier : "-"),
              col4,
              41
            );
            doc.text(": " + String(data.notes || "-"), col4, 48);

            // Divider
            doc.setDrawColor(200, 200, 200);
            doc.line(col1, 54, pageW - 14, 54);

            // ── Table ────────────────────────────────────────────────
            var formatNum = function (val) {
              if (val == null || val === "") return "0";
              return Intl.NumberFormat("en", {
                minimumFractionDigits: 0,
              }).format(Math.round(Number(val)));
            };

            var head = [
              [
                { content: "No", styles: { halign: "center" } },
                {
                  content: "Customer Code\n& Name",
                  styles: { halign: "center" },
                },
                { content: "Total Sales", styles: { halign: "center" } },
                { content: "Avg Sales", styles: { halign: "center" } },
                {
                  content: "Active\nTransaction",
                  styles: { halign: "center" },
                },
                { content: "AR Overdue", styles: { halign: "center" } },
                {
                  content: "Avg Payment\n(days)",
                  styles: { halign: "center" },
                },
                { content: "Late\nPayment", styles: { halign: "center" } },
                {
                  content: "Avg Late\nPayment (days)",
                  styles: { halign: "center" },
                },
                { content: "Current CL", styles: { halign: "center" } },
                { content: "Suggested CL", styles: { halign: "center" } },
                { content: "New CL\n(Request)", styles: { halign: "center" } },
                { content: "Exclude", styles: { halign: "center" } },
              ],
            ];

            var body = [];
            for (var i = 0; i < customers.length; i++) {
              var v = customers[i];
              body.push([
                { content: String(i + 1), styles: { halign: "center" } },
                {
                  content:
                    String(v.customer_code || "") +
                    "\n" +
                    String(v.customer_name || ""),
                  styles: { halign: "left" },
                },
                {
                  content: formatNum(v.total_sales),
                  styles: { halign: "right" },
                },
                {
                  content: formatNum(v.total_average_sales),
                  styles: { halign: "right" },
                },
                {
                  content: String(
                    v.active_transaction != null ? v.active_transaction : 0
                  ),
                  styles: { halign: "center" },
                },
                {
                  content: formatNum(v.ar_overdue),
                  styles: { halign: "right" },
                },
                {
                  content: String(
                    v.average_payment != null ? v.average_payment : 0
                  ),
                  styles: { halign: "center" },
                },
                {
                  content: String(
                    v.num_of_late_payment != null ? v.num_of_late_payment : 0
                  ),
                  styles: { halign: "center" },
                },
                {
                  content: String(
                    v.average_late_payment != null ? v.average_late_payment : 0
                  ),
                  styles: { halign: "center" },
                },
                {
                  content: formatNum(v.current_credit_limit),
                  styles: { halign: "right" },
                },
                {
                  content: formatNum(v.suggested_credit_limit),
                  styles: { halign: "right" },
                },
                {
                  content: formatNum(v.credit_limit_request),
                  styles: { halign: "right" },
                },
                {
                  content: v.is_exclude ? "Yes" : "No",
                  styles: { halign: "center" },
                },
              ]);
            }

            autoTable(doc, {
              startY: 58,
              head: head,
              body: body,
              margin: { left: col1, right: 14 },
              theme: "grid",
              headStyles: {
                fillColor: [94, 77, 178],
                textColor: [255, 255, 255],
                fontStyle: "bold",
                fontSize: 7.5,
                halign: "center",
                valign: "middle",
                cellPadding: 3,
              },
              bodyStyles: {
                fontSize: 7.5,
                textColor: [44, 62, 80],
                cellPadding: { top: 3, right: 3, bottom: 3, left: 3 },
              },
              alternateRowStyles: {
                fillColor: [248, 249, 250],
              },
              columnStyles: {
                0: { cellWidth: 8 },
                1: { cellWidth: 40 },
                2: { cellWidth: 24 },
                3: { cellWidth: 24 },
                4: { cellWidth: 18 },
                5: { cellWidth: 24 },
                6: { cellWidth: 20 },
                7: { cellWidth: 16 },
                8: { cellWidth: 20 },
                9: { cellWidth: 26 },
                10: { cellWidth: 26 },
                11: { cellWidth: 26 },
                12: { cellWidth: 14 },
              },
              didDrawPage: function (hookData) {
                // Footer on each page
                var pageCount = doc.internal.getNumberOfPages();
                doc.setFontSize(7);
                doc.setTextColor(150, 150, 150);
                doc.text(
                  "Page " + hookData.pageNumber + " of " + pageCount,
                  pageW / 2,
                  doc.internal.pageSize.getHeight() - 6,
                  { align: "center" }
                );
              },
            });

            doc.save(fileTitle + ".pdf");
            this.$vs.loading.close();
          }
        });
    },
  },
  watch: {
    draw() {
      this.getData();
    },
    table: {
      handler() {
        this.table.data.credit_limit_reguler_customers.forEach((element) => {
          if (element.credit_limit_request < 0) {
            element.credit_limit_request = 1;
          }
        });
      },
      deep: true,
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(value)
          .add(-7, "h")
          .utc()
          .local()
          .format("DD MMM YYYY HH:mm:ss");
      }
    },
    numberFormat(value) {
      if (value) {
        // if (value > 0) {
        value = Math.round(value);
        return Intl.NumberFormat("en", {
          minimumFractionDigits: 0,
        }).format(value);

        // return Intl.NumberFormat("en", {
        //   minimumFractionDigits: 0,
        // }).format(value);
      } else {
        return 0;
      }
    },
    monthFormat(value) {
      if (value) {
        return moment()
          .month(value - 1)
          .format("MMMM");
      }
    },
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>

<style scoped>
/* Credit Limit Table Styling */
.credit-limit-table {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.customer-code {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  padding: 8px 0;
}

.data-cell {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
}

.data-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  background: #f8f9fa;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.data-row:hover {
  background: #e9ecef;
  transform: translateX(2px);
}

.data-row .label {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
  flex: 1;
}

.data-row .value {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 600;
  text-align: right;
  margin-left: 12px;
}

/* Month Transaction Container - New Design */
.month-transaction-container {
  padding: 12px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.month-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #5e4db2 0%, #7c3aed 100%);
  border-radius: 8px;
  color: white;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  box-shadow: 0 3px 8px rgba(94, 77, 178, 0.4);
}

.month-header svg {
  color: white;
}

.month-cards {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.month-card {
  background: white;
  border-radius: 8px;
  padding: 10px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-left: 4px solid transparent;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.month-card:nth-child(1) {
  border-left-color: #5e4db2;
}

.month-card:nth-child(2) {
  border-left-color: #7c3aed;
}

.month-card:nth-child(3) {
  border-left-color: #a78bfa;
}

.month-card:hover {
  transform: translateX(4px) scale(1.02);
  box-shadow: 0 4px 12px rgba(94, 77, 178, 0.3);
  background: linear-gradient(135deg, #ffffff 0%, #faf5ff 100%);
}

.month-name {
  font-size: 12px;
  font-weight: 600;
  color: #5e4db2;
  text-transform: capitalize;
  letter-spacing: 0.3px;
}

.month-amount {
  font-size: 14px;
  font-weight: 700;
  color: #2c3e50;
  text-align: right;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: white;
  border-radius: 8px;
  color: #9ca3af;
  gap: 8px;
}

.empty-state svg {
  color: #d1d5db;
}

.empty-state span {
  font-size: 12px;
  font-weight: 500;
  color: #9ca3af;
}

.month-data .data-row {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.month-data .data-row .label,
.month-data .data-row .value {
  color: white;
}

.month-data .data-row:hover {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
}

.amount-cell {
  font-size: 15px;
  font-weight: 700;
  color: #2c3e50;
  padding: 12px;
  background: #e3f2fd;
  border-radius: 6px;
  text-align: right;
  border-left: 4px solid #2196f3;
  transition: all 0.2s ease;
}

.amount-cell:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.2);
}

.amount-cell.suggested {
  background: #e8f5e9 !important;
  border-left-color: #4caf50 !important;
  color: #1b5e20 !important;
  font-weight: 700;
}

.amount-cell.suggested:hover {
  box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3) !important;
}

.amount-cell.new-cl {
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%) !important;
  border-left-color: #ff9800 !important;
  color: #e65100 !important;
  font-weight: 700;
}

.amount-cell.new-cl:hover {
  box-shadow: 0 4px 8px rgba(255, 152, 0, 0.3) !important;
  transform: translateY(-2px);
}

/* Table header styling */
.credit-limit-table ::v-deep .vs-table--thead th {
  background: linear-gradient(135deg, #5e4db2 0%, #7c3aed 100%) !important;
  color: white !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  padding: 18px 14px !important;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  border-bottom: 3px solid #6d28d9 !important;
}

/* Table row styling */
.credit-limit-table ::v-deep .vs-table--tbody tr {
  transition: all 0.2s ease;
}

.credit-limit-table ::v-deep .vs-table--tbody tr:hover {
  background: #f8f9fa !important;
  transform: scale(1.01);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.credit-limit-table ::v-deep .vs-table--tbody td {
  padding: 16px 12px !important;
  vertical-align: top;
}

/* Zebra striping */
.credit-limit-table ::v-deep .vs-table--tbody tr:nth-child(even) {
  background: #fafafa;
}

/* Input field styling in table */
.credit-limit-table ::v-deep .vs-input {
  border-radius: 6px;
  border: 2px solid #e0e7ff;
  transition: all 0.2s ease;
}

.credit-limit-table ::v-deep .vs-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* Checkbox styling */
.credit-limit-table ::v-deep .vs-checkbox {
  transform: scale(1.2);
}
</style>
